// ✅ SEO IMPROVEMENT: Link to SEO activity pages instead of search pages
// Order is important
export const DISCIPLINES_TO_SLIDE = [
  {
    key: 'mountainHiking',
    seoSlugs: {
      'en-US': 'hiking',
      'de-DE': 'wandern',
      'fr-FR': 'randonnee',
      'it-IT': 'escursionismo',
    },
    srcImg: '/static/imgs/disciplines/hiking/mountainHiking.avif',
  },
  {
    key: 'alpineSkiing',
    seoSlugs: {
      'en-US': 'alpine-skiing',
      'de-DE': 'skifahren',
      'fr-FR': 'ski-alpin',
      'it-IT': 'sci-alpino',
    },
    srcImg: '/static/imgs/disciplines/skiing/alpineSkiing.avif',
  },
  {
    key: 'mountainBiking',
    seoSlugs: {
      'en-US': 'mountain-biking',
      'de-DE': 'mountainbiken',
      'fr-FR': 'vtt',
      'it-IT': 'mtb',
    },
    srcImg: '/static/imgs/disciplines/biking/mountainBiking.avif',
  },
  {
    key: 'snowShoeing',
    seoSlugs: {
      'en-US': 'snowshoeing',
      'de-DE': 'schneeschuhwandern',
      'fr-FR': 'raquettes-neige',
      'it-IT': 'ciaspolata',
    },
    srcImg: '/static/imgs/disciplines/hiking/snowShoeing.avif',
  },
  {
    key: 'guidedWalking',
    seoSlugs: {
      'en-US': 'guided-walking',
      'de-DE': 'gefuehrte-wanderung',
      'fr-FR': 'randonnee-guidee',
      'it-IT': 'passeggiata-guidata',
    },
    srcImg: '/static/imgs/disciplines/otherExperiences/guidedWalking.avif',
  },
  {
    key: 'onPisteSnowboarding',
    seoSlugs: {
      'en-US': 'on-piste-snowboarding',
      'de-DE': 'snowboarden-auf-der-piste',
      'fr-FR': 'snowboard-sur-piste',
      'it-IT': 'snowboard-su-pista',
    },
    srcImg: '/static/imgs/disciplines/snowboarding/onPisteSnowboarding.avif',
  },
  {
    key: 'skiTouring',
    seoSlugs: {
      'en-US': 'ski-touring',
      'de-DE': 'skitouren',
      'fr-FR': 'ski-de-randonnee',
      'it-IT': 'sci-alpinismo',
    },
    srcImg: '/static/imgs/disciplines/skiing/skiTouring.avif',
  },
  {
    key: 'northernLights',
    seoSlugs: {
      'en-US': 'northern-lights',
      'de-DE': 'nordlicht',
      'fr-FR': 'aurores-boreales',
      'it-IT': 'aurora-boreale',
    },
    srcImg: '/static/imgs/disciplines/otherExperiences/northernLights.avif',
  },
  {
    key: 'paragliding',
    seoSlugs: {
      'en-US': 'paragliding',
      'de-DE': 'gleitschirmfliegen',
      'fr-FR': 'parapente',
      'it-IT': 'parapendio',
    },
    srcImg: '/static/imgs/disciplines/airSports/paragliding.avif',
  },
  {
    key: 'huskySledding',
    seoSlugs: {
      'en-US': 'husky-sledding',
      'de-DE': 'husky-rodeln',
      'fr-FR': 'traineau-husky',
      'it-IT': 'slitta-ad-husky',
    },
    srcImg: '/static/imgs/disciplines/sledging/huskySledding.avif',
  },
    {
    key: 'mountaineering',
    seoSlugs: {
      'en-US': 'mountaineering',
      'de-DE': 'bergsteigen',
      'fr-FR': 'alpinisme',
      'it-IT': 'alpinismo',
    },
    srcImg: '/static/imgs/disciplines/climbing/mountaineering.avif',
  },
  {
    key: 'freerideSkiing',
    seoSlugs: {
      'en-US': 'freeride-skiing',
      'de-DE': 'freeride-skifahren',
      'fr-FR': 'ski-freeride',
      'it-IT': 'sci-freeride',
    },
    srcImg: '/static/imgs/disciplines/skiing/freerideSkiing.avif',
  },
  {
    key: 'tobogganing',
    seoSlugs: {
      'en-US': 'tobogganing',
      'de-DE': 'rodeln',
      'fr-FR': 'luge',
      'it-IT': 'slittino',
    },
    srcImg: '/static/imgs/disciplines/sledging/tobogganing.avif',
  },
  {
    key: 'freerideSnowboarding',
    seoSlugs: {
      'en-US': 'freeride-snowboarding',
      'de-DE': 'freeride-snowboarden',
      'fr-FR': 'snowboard-freeride',
      'it-IT': 'snowboard-freeride',
    },
    srcImg: '/static/imgs/disciplines/snowboarding/freerideSnowboarding.avif',
  },
  {
    key: 'fatBiking',
    seoSlugs: {
      'en-US': 'fat-biking',
      'de-DE': 'fatbiken',
      'fr-FR': 'fat-bike',
      'it-IT': 'fat-bike',
    },
    srcImg: '/static/imgs/disciplines/biking/fatBiking.avif',
  },
  {
    key: 'telemarkSkiing',
    seoSlugs: {
      'en-US': 'telemark-skiing',
      'de-DE': 'telemark-skifahren',
      'fr-FR': 'ski-telemark',
      'it-IT': 'sci-telemark',
    },
    srcImg: '/static/imgs/disciplines/skiing/telemarkSkiing.avif',
  },
  {
    key: 'rockClimbing',
    seoSlugs: {
      'en-US': 'rock-climbing',
      'de-DE': 'klettern',
      'fr-FR': 'escalade',
      'it-IT': 'arrampicata',
    },
    srcImg: '/static/imgs/disciplines/climbing/rockClimbing.avif',
  },
  {
    key: 'iceClimbing',
    seoSlugs: {
      'en-US': 'ice-climbing',
      'de-DE': 'eisklettern',
      'fr-FR': 'escalade-sur-glace',
      'it-IT': 'arrampicata-su-ghiaccio',
    },
    srcImg: '/static/imgs/disciplines/climbing/iceClimbing.avif',
  },
  {
    key: 'splitBoarding',
    seoSlugs: {
      'en-US': 'splitboarding',
      'de-DE': 'splitboarden',
      'fr-FR': 'splitboard',
      'it-IT': 'splitboard',
    },
    srcImg: '/static/imgs/disciplines/snowboarding/splitBoarding.avif',
  },
 {
    key: 'canyoning',
    seoSlugs: {
      'en-US': 'canyoning',
      'de-DE': 'canyoning',
      'fr-FR': 'canyoning',
      'it-IT': 'canyoning',
    },
    srcImg: '/static/imgs/disciplines/riverSports/canyoning.avif',
  },
  {
    key: 'horseRiding',
    seoSlugs: {
      'en-US': 'horse-riding',
      'de-DE': 'reiten',
      'fr-FR': 'equitation',
      'it-IT': 'equitazione',
    },
    srcImg: '/static/imgs/disciplines/horseRiding/horseRiding.avif',
  },
  {
    key: 'viaFerrata',
    seoSlugs: {
      'en-US': 'via-ferrata',
      'de-DE': 'klettersteig',
      'fr-FR': 'via-ferrata',
      'it-IT': 'via-ferrata',
    },
    srcImg: '/static/imgs/disciplines/climbing/viaFerrata.avif',
  },
  {
    key: 'eBiking',
    seoSlugs: {
      'en-US': 'e-biking',
      'de-DE': 'e-biken',
      'fr-FR': 'velo-electrique',
      'it-IT': 'e-bike',
    },
    srcImg: '/static/imgs/disciplines/biking/eBiking.avif',
  },
  {
    key: 'kayaking',
    seoSlugs: {
      'en-US': 'kayaking',
      'de-DE': 'kajakfahren',
      'fr-FR': 'kayak',
      'it-IT': 'kayak',
    },
    srcImg: '/static/imgs/disciplines/lakeAndSeaSports/kayaking.avif',
  },
  {
    key: 'culinaryTasting',
    seoSlugs: {
      'en-US': 'food-and-wine-walking',
      'de-DE': 'kulinarische-weinwanderung',
      'fr-FR': 'balade-enogastronomique',
      'it-IT': 'passeggiata-enogastronomica',
    },
    srcImg: '/static/imgs/disciplines/otherExperiences/culinaryTasting.avif',
  },
  {
    key: 'roadCycling',
    seoSlugs: {
      'en-US': 'road-cycling',
      'de-DE': 'strasenradfahren',
      'fr-FR': 'cyclisme-sur-route',
      'it-IT': 'ciclismo-su-strada',
    },
    srcImg: '/static/imgs/disciplines/biking/roadCycling.avif',
  },
  {
    key: 'trailRunning',
    seoSlugs: {
      'en-US': 'trail-running',
      'de-DE': 'trailrunning',
      'fr-FR': 'trail',
      'it-IT': 'trail-running',
    },
    srcImg: '/static/imgs/disciplines/running/trailRunning.avif',
  },
  {
    key: 'rafting',
    seoSlugs: {
      'en-US': 'rafting',
      'de-DE': 'rafting',
      'fr-FR': 'rafting',
      'it-IT': 'rafting',
    },
    srcImg: '/static/imgs/disciplines/riverSports/rafting.avif',
  },
  {
    key: 'tennis',
    seoSlugs: {
      'en-US': 'tennis',
      'de-DE': 'tennis',
      'fr-FR': 'tennis',
      'it-IT': 'tennis',
    },
    srcImg: '/static/imgs/disciplines/courtSports/tennis.avif',
  },
  {
    key: 'bouldering',
    seoSlugs: {
      'en-US': 'bouldering',
      'de-DE': 'bouldern',
      'fr-FR': 'bloc',
      'it-IT': 'boulder',
    },
    srcImg: '/static/imgs/disciplines/climbing/bouldering.avif',
  },
  {
    key: 'sailing',
    seoSlugs: {
      'en-US': 'sailing',
      'de-DE': 'segeln',
      'fr-FR': 'voile',
      'it-IT': 'vela',
    },
    srcImg: '/static/imgs/disciplines/lakeAndSeaSports/sailing.avif',
  },
  {
    key: 'bungeeJumping',
    seoSlugs: {
      'en-US': 'bungee-jumping',
      'de-DE': 'bungee-jumping',
      'fr-FR': 'saut-lelastique',
      'it-IT': 'bungee-jumping',
    },
    srcImg: '/static/imgs/disciplines/airSports/bungeeJumping.avif',
  },
  {
    key: 'yoga',
    seoSlugs: {
      'en-US': 'yoga',
      'de-DE': 'yoga',
      'fr-FR': 'yoga',
      'it-IT': 'yoga',
    },
    srcImg: '/static/imgs/disciplines/otherExperiences/yoga.avif',
  },
  {
    key: 'padel',
    seoSlugs: {
      'en-US': 'padel',
      'de-DE': 'padel',
      'fr-FR': 'padel',
      'it-IT': 'padel',
    },
    srcImg: '/static/imgs/disciplines/courtSports/padel.avif',
  },
  {
    key: 'crossCountrySkiing',
    seoSlugs: {
      'en-US': 'cross-country-skiing',
      'de-DE': 'langlaufen',
      'fr-FR': 'ski-de-fond',
      'it-IT': 'sci-di-fondo',
    },
    srcImg: '/static/imgs/disciplines/skiing/crossCountrySkiing.avif',
  },
  {
    key: 'avalancheTraining',
    seoSlugs: {
      'en-US': 'avalanche-training',
      'de-DE': 'lawinentraining',
      'fr-FR': 'formation-avalanche',
      'it-IT': 'addestramento-valanghe',
    },
    srcImg: '/static/imgs/disciplines/otherExperiences/avalancheTraining.avif',
  }, 
];
